"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Project_1 = require("./Project");
const ProjectDiff_1 = require("./ProjectDiff");
class ProjectChange {
    constructor({ updatedAt, project, latestVersion, beforeVersion, }) {
        this.toJSON = () => ({
            updatedAt: this.updatedAt,
            project: this.project.toJSON(),
            latestVersion: this.latestVersion,
            beforeVersion: this.beforeVersion,
        });
        this.updatedAt = updatedAt;
        this.project = project;
        this.latestVersion = latestVersion;
        this.beforeVersion = beforeVersion;
    }
}
ProjectChange.fromJSON = (json) => {
    const { updatedAt, project, latestVersion, beforeVersion } = Object.assign({}, json);
    if (typeof updatedAt !== 'string')
        throw new Error('.updatedAt must be a string');
    const _project = Project_1.default.fromJSON(project);
    const creativeBriefDefinition = _project.creativeBriefDefinition;
    const assetCategoryDefinition = _project.assetCategoryDefinition;
    const _latestVersion = ProjectDiff_1.default.fromJSON(latestVersion, creativeBriefDefinition, assetCategoryDefinition);
    const _beforeVersion = ProjectDiff_1.default.fromJSON(beforeVersion, creativeBriefDefinition, assetCategoryDefinition);
    return new ProjectChange({
        updatedAt,
        project: _project,
        latestVersion: _latestVersion,
        beforeVersion: _beforeVersion,
    });
};
exports.default = ProjectChange;
